import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonBindingDataService } from '../../services/common-binding-data.service';
import { PageHeaderService } from '../../services/page-header.service';
import { SidebarService } from '../../services/sidebar.service';

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.scss']
})
export class AccessDeniedComponent implements OnInit, OnDestroy {

  constructor(
    private router: Router,
    private commonBindingDataService: CommonBindingDataService,
    private pageHeaderService: PageHeaderService,
    private sidebarService: SidebarService
  ) { }

  ngOnInit(): void {
    const title = this.commonBindingDataService.getLabel('title_access_denied');
    this.pageHeaderService.setFromPage({
      breadcrumbs: [{ label: title }],
      title,
      showBack: false
    });
    console.log(window.history.back);
  }

  ngOnDestroy(): void {
    this.pageHeaderService.clear();
  }

  goBack(): void {
    const menu = this.sidebarService.sideBarMenu;
    if (menu && menu.length > 0) {
      const firstMenu = menu[0];
      this.router.navigate(firstMenu.routerLink);
    }
  }
}
